module.exports = __webpack_public_path__ + "static/educator-f9755cac0958f7428e56259017d52f38.png";